import { render, staticRenderFns } from "./create.vue?vue&type=template&id=797ba58c&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=797ba58c&lang=scss&scoped=true&"
import style1 from "./create.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ba58c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797ba58c')) {
      api.createRecord('797ba58c', component.options)
    } else {
      api.reload('797ba58c', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=797ba58c&scoped=true&", function () {
      api.rerender('797ba58c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulletin/create.vue"
export default component.exports